import { isError } from 'flux-standard-action';
import { defaultsDeep } from 'lodash';
import { metaExtractor, payloadExtractor } from 'app-webtech-core/reducers/payloadExtractor';
import { updateState } from 'app-webtech-core/reducers/updateState';
import { VOD_CONTENT_STATE_STATUSES } from '../constants';

const requestMutationGenerator = (payload, { params }) => ({
  params: (currentParams) => ({ ...currentParams, ...params }),
  status: { $set: VOD_CONTENT_STATE_STATUSES.PENDING },
  error: { $set: null },
});

const successMutationGenerator = ({ result, entities, totalCategories, totalPages }) => ({
  params: (currentParams) => ({ ...currentParams, totalCategories, totalPages }),
  result: (currentResult) => [...new Set([...currentResult, ...result])],
  entities: (
    currentEntities = {
      vodContent: {},
      vodEpisodes: {},
    },
  ) => {
    const res = defaultsDeep({}, currentEntities, entities);
    res.vodContent = { ...res.vodContent, ...res.vodEpisodes };
    return res;
  },
  status: { $set: VOD_CONTENT_STATE_STATUSES.DONE },
  error: { $set: null },
});

const errorMutationGenerator = (error, { params }) => ({
  params: (currentParams) => ({ ...currentParams, ...params }),
  result: { $set: [] },
  entities: { $set: {} },
  status: { $set: VOD_CONTENT_STATE_STATUSES.ERROR },
  error: { $set: error },
});

export const vodContentFetchAllRequestReducer = (currentState, action) =>
  updateState(
    currentState,
    (isError(action) ? errorMutationGenerator : requestMutationGenerator)(
      payloadExtractor(action),
      metaExtractor(action),
    ),
  );

export const vodContentFetchAllSuccessReducer = (currentState, action) =>
  updateState(
    currentState,
    (isError(action) ? errorMutationGenerator : successMutationGenerator)(
      payloadExtractor(action),
      metaExtractor(action),
    ),
  );

export const vodContentFetchAllFailureReducer = (currentState, action) =>
  updateState(
    currentState,
    errorMutationGenerator(payloadExtractor(action), metaExtractor(action)),
  );
